<template>
    <div class="step-wrapper">
        <div class="step-header">
            <h2 class="step-title">Who will be signing your lease?</h2>
        </div>

        <div class="step-body">
            <CardSelector
                :options="cosignerOptions"
                :value="selectedValue"
                :vertical="true"
                @input="onSelect"
            />
        </div>

        <div class="step-footer">
            <v-btn
                color="primary"
                depressed
                block
                height="50"
                :disabled="!selectedValue"
                @click="onNext"
                class="next-btn"
            >
                Next
            </v-btn>
        </div>
    </div>
</template>

<script>
import CardSelector from '../shared/CardSelector.vue';

export default {
    name: 'CosignersStep',

    components: {
        CardSelector
    },

    data() {
        return {
            cosignerOptions: [
                {
                    value: 'cosigner',
                    label: 'I have a co-signer',
                    description: 'Parent or guardian with verifiable income',
                    icon: 'mdi-account-check'
                },
                {
                    value: 'self',
                    label: "I'll be leasing by myself",
                    description: 'No co-signer/I have verifiable income',
                    icon: 'mdi-account'
                }
            ]
        };
    },

    computed: {
        selectedValue() {
            return this.$store.getters['Questionnaire/getAnswer']('cosignerType');
        }
    },

    methods: {
        onSelect(value) {
            this.$store.dispatch('Questionnaire/setAnswer', {
                key: 'cosignerType',
                value
            });
        },

        onNext() {
            if (this.selectedValue) {
                this.$emit('next');
            }
        }
    }
};
</script>

<style scoped>
.step-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.step-header {
    text-align: center;
    margin-bottom: 32px;
}

.step-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin-bottom: 8px;
}

.step-subtitle {
    font-size: 16px;
    color: #666;
}

.step-body {
    flex: 1;
}

.step-footer {
    margin-top: auto;
    padding-top: 24px;
}

.next-btn {
    font-weight: 600;
    text-transform: none;
    font-size: 16px;
    border-radius: 8px;
}
</style>
